/* eslint-disable */
// All ESLint errors will be ignored in this file
import apiClient, { ApiClient } from '../utils/apiClient';

/**
 * Prompt Service - Handles all prompt-related API calls
 */
class PromptService {
  /**
   * Get list of prompts for the current user, based on the input which could be email or domain and also use case
   * @returns {Promise<Object>} User profile data
   */
  getPromptListForAccount(useCase = null) {
    const params = { input: 'revenueos.com' };
    if (useCase !== null) {
      params.use_case = useCase;
    }
    return apiClient.getJson('/api/prompts', params);
  }

  getPromptListForContact(useCase = null) {
    const params = { input: 'hello@revenueos.com' };
    if (useCase !== null) {
      params.use_case = useCase;
    }
    return apiClient.getJson('/api/prompts', params);
  }

  askPromptWithPrerequisites(task, inputUrl, sessionId = null) {
    let params = {input: inputUrl};
    if (sessionId !== null) {
      params.session_id = sessionId;
    }

    let url = ApiClient.appendQueryParams('/api/prompts/ask-with-prerequisite', params);
    console.log('askPromptWithPrerequisites', url, task);
    return apiClient.postJson(url, task);
  }

}

// Create singleton instance
const promptService = new PromptService();

export default promptService;
